import { render, staticRenderFns } from "./fan-carousel.vue?vue&type=template&id=119b1040&scoped=true"
import script from "./fan-carousel.vue?vue&type=script&lang=js"
export * from "./fan-carousel.vue?vue&type=script&lang=js"
import style0 from "./fan-carousel.vue?vue&type=style&index=0&id=119b1040&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b1040",
  null
  
)

export default component.exports